<div class="d-flex flex-column">
    <div class="login-top-bar d-flex flex-row justify-content-between align-items-center">
        <div class="logo-container pointer">
            <a href="https://knowledgehook.com" [khA11yLabel]="'A11Y_LABEL.KNOWLEDGEHOOK_HOME' | translate">
                <kh-img path="kh-logo.svg" class="desktop logo" khA11yHidden></kh-img>
                <kh-img path="kh-logo-book-only.svg" class="mobile logo" khA11yHidden></kh-img>
            </a>
        </div>
    </div>
    <div class="d-flex flex-column align-items-center montserrat justify-content-center">
        <div class="kh-text-primary kh-heading-sm text-center mb-kh-4 pt-kh-7">{{ 'MERGE_COMPLETE.MERGE_SUCCESSFUL' | translate }}</div>
        <div class="kh-text-primary kh-body-lg text-center mb-kh-4">{{ 'MERGE_COMPLETE.YOU_MAY_CLOSE_THIS_WINDOW' | translate }}</div>
    </div>
</div>




